<script>
  import {onMount, createEventDispatcher} from 'svelte';
  import {goto} from '@sapper/app';
  import {PATHS} from '@/const/paths';
  import {resetSecurity$} from '@/store/reset-security';
  import {fixLink$} from '@/store/lang';
  import VerifyCodeInput from '@/widgets/VerifyCodeInput.svelte';
  import DrawerModal from '@/widgets/DrawerModal.svelte';
  import {resetSecurityType$} from '@/modules/reset-security/stream';
  import errors from '@/modules/error/error.lang';
  import lang from '../RegisterLandingPage.lang';

  export let LG = null;
  export let googleData = null;

  const dispatch = createEventDispatcher();

  let status = '';
  let explain = '';
  let contextRef = null;
  let callbackRef = null;

  onMount(() => {
    status = '';
    explain = '';
    contextRef = googleData.context;
    callbackRef = googleData.callback;
  });

  function handleCodeChange(e) {
    const googleCode = e.detail.value;
    status = 'loading';
    const callback = ({code, message}) => {
      if (code === 0) {
        handleClickClose();
        status = 'success';
        return;
      }
      status = 'fail';
      const id = errors[code];
      explain = id ? LG(id) : message;
    };
    callbackRef && callbackRef(googleCode, callback, contextRef);
  }

  function handleInputCode() {
    status = '';
    explain = '';
  }

  function handleClickClose() {
    resetData();
    dispatch('close');
  }

  function resetData() {
    status = '';
    explain = '';
    contextRef = null;
    callbackRef = null;
  }

  function handleClickReset() {
    resetSecurity$.set({email: contextRef.email, code: contextRef.code});
    resetSecurityType$.next({balanceType: 0, resetRecordId: 0, resetRecordStatus: 0, remain_count: 0, code: 0, answerStatus: 0});
    dispatch('close');
    goto($fixLink$(PATHS.RESET_SECURITY.pathname));
  }
</script>

<style>
  .wrap {
    height: 100%;
    padding-top: 60px;
    margin-top: 54px;
  }
  .title {
    margin-top: 24px;
    font-size: 32px;
  }
  .sub-title {
    margin-top: 20px;
  }
  .iconfont {
    font-size: 12px;
  }
  .arrow{
    color: #999B9F;
  }
  .arrow i {
    transform: rotate(-180deg);
  }
  .arrow:hover{
    color: var(--blue);
  }
  .coin {
    margin-top: 58px;
  }
  img {
    width: 80px;
    height: 80px;
  }
  .code :global(.digit-box span) {
    font-size: 36px;
    font-weight: var(--fw3);
    color: var(--T1);
  }
  .code :global(.digit-box) {
    border: 1px solid #DCDFE5;
    width: 60px;
    height: 75px;
    border-radius: 8px;
  }
  .code :global(.active.digit-box) {
    border-color: var(--blue-main-active);
  }
  .c-grey{
    color: #6C6E74;
  }
  @media screen and (max-width: 640px) {
    .code :global(.digit-box) {
      height: 50px;
    }
  }
</style>

<DrawerModal visible>
  <div class="wrap">
    <div class="wp100">
      <div class="df aic cp arrow" on:click={handleClickClose}>
        <i class="iconfont">&#xe60b;</i>
        <span class="ml10">{LG(lang.Back)}</span>
      </div>
      <div class="form">
  <!--      <div class="coin">-->
  <!--        <img src="https://static.phemex.com/pubimg/60b8b5093c3731e9abc40e6bc4ba21b750a5325fca413793122a8e0ebbcdbd3d.png" alt="google-coin" />-->
  <!--      </div>-->
        <div class="mt24 title lh48 fw3">{LG(lang.GoogleVerification)}</div>
        <div class="sub-title f12 c-grey">{LG(lang.PleaseEnterGoogle)}</div>
        <div class="code mt16">
          <VerifyCodeInput class="sidebar-verification-code" {status} {explain} on:change={handleCodeChange} on:input={handleInputCode} />
        </div>
        <div class="mt20 f12 lh16 cp T1 fw3" on:click={handleClickReset}>{LG(lang.SecurityVerificationUnavailable)}</div>
      </div>
    </div>
  </div>
</DrawerModal>
